import React from "react";
import { makeStyles } from "@material-ui/core";

function PageBanner(props) {
  const { title, image, titleAlign, size } = props;
  const useStyles = makeStyles((theme) => ({
    banner: {
      width: "100%",
      height: size === "small" ? "200px" : "230px",
      backgroundImage: `url(${image})`,
      backgroundSize: "cover",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "black",
      [theme.breakpoints.down("sm")]: {
        height: size === "small" ? "250px" : "500px",
      },
    },
    bannerContainer: {
      textAlign: titleAlign ? titleAlign : "center",
      width: "90%",
      margin: "0 auto",
      // backgroundColor: 'red'
    },
    bannerHeading: {
      fontSize: "64px",
      fontWeight: 500,
      margin: "50px 0px 0px 0px",
      letterSpacing: 0.1,
      [theme.breakpoints.down("md")]: {
        fontSize: "54px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "45px",
      },
    },
  }));

  const classes = useStyles();
  return (
    <div className={classes.banner}>
      <div className={classes.bannerContainer}>
        <h2 className={classes.bannerHeading}>{title}</h2>
      </div>
    </div>
  );
}

export default PageBanner;
